import axios, { AxiosRequestConfig } from "axios";
import * as ENDPOINTS from "../../../routes/ApiEndpoints";
import { getHeaders } from "./apiUtils";

async function fileUploadService(formData: any, path: string, microserviceURL: string = "") {
  const headersarray: any = await headers();
  const microService: string = microserviceURL !== null && microserviceURL !== "" && microserviceURL !== undefined ? microserviceURL : `${process.env.REACT_APP_BACKEND_SERVICE}`;
  return await axios
    .post(
      `${microService}/${ENDPOINTS.FILE_UPLOAD}/${path}`,
      formData,
      headersarray
    )
    .then((result) => {
      return result.data;
    })
    .catch((error) => {
      console.log("Error service : ", error);
    });
}


async function fileDeleteService(path: string, id: number, microserviceURL: string = "") {
  const headersarray: any = await headers();
  const microService: string = microserviceURL !== null && microserviceURL !== "" && microserviceURL !== undefined ? microserviceURL : `${process.env.REACT_APP_BACKEND_SERVICE}`;

  return await axios
    .post(
      `${microService}/${ENDPOINTS.FILE_DELETE}`,
      { path, id },
      headersarray
    )
    .then((result) => {
      return result.data;
    })
    .catch((error) => {
      console.log("Error service : ", error);
    });
}

/**
 * Send uploaded file data to any backend microservice 
 *
 * @param baseUrl: any
 * @param endPoint: string
 * @param formData: any
 *
 */
async function sendFileService(baseUrl: any, endPoint: string, formData: any) {

  const headersarray: any = await headers();

  return await axios
    .post(
      `${baseUrl}/${endPoint}`,
      formData,
      headersarray
    )
    .then((result) => {
      return result.data;
    })
    .catch((error) => {
      console.log("Error service : ", error);
    });
}

/*
 *Getting headers for the Ajax
 *@param data =data to the API
 *@param httpmethod=METHOD
 *returns headers for the Ajax
 */
// TO-38127 (f_fesec_05b3a89721): send the authenticated user's token via the shared getHeaders()
// helper instead of a static REACT_APP_BEARER_TOKEN baked into the JS bundle. The upload/delete
// routes are behind auth:sanctum (TO-38233), so they expect the user's Sanctum token, not a shared
// secret. Client-side encryption of the token added nothing (HTTPS already protects transit and the
// key shipped in the bundle) and is dropped.
export const headers = async (): Promise<AxiosRequestConfig> => {
  const authHeaders = await getHeaders(false, true); // isJson=false, isFormData=true -> multipart/form-data
  return { headers: authHeaders as AxiosRequestConfig["headers"] };
};

export const AxiosCall = {
  fileUploadService,
  fileDeleteService,
  sendFileService,
};
